import { useState, useMemo } from 'react';
import { BackupConfigProps } from '../types';

export const useConfigValidation = (config: BackupConfigProps['config']) => {
  const [errors, setErrors] = useState<string[]>([]);

  const validate = (): boolean => {
    const errs: string[] = [];
    
    if (config.enabled) {
      if (config.driver === 'github') {
        if (!config.github?.owner || !config.github?.repo) {
          errs.push('GitHub owner and repository are required. Use Connect GitHub to pick a repo.');
        }
      }
      
      if (config.driver === 's3') {
        const s3 = config.s3;
        if (!s3?.accessKeyId || !s3?.secretAccessKey || !s3?.region || !s3?.bucket) {
          errs.push('S3 accessKeyId, secretAccessKey, region and bucket are required');
        }
      }
      
      if (import.meta.env.MODE === 'production' && config.driver === 'local') {
        errs.push('Local storage is not allowed in production');
      }
      
      if (config.driver === 'sftp') {
        errs.push('SFTP will be enabled next stage (backend adapter).');
      }
    }
    
    setErrors(errs);
    return errs.length === 0;
  };

  const isValid = useMemo(() => errors.length === 0, [errors]);

  return { errors, validate, isValid };
};